export default "__VITE_ASSET__5086ec70__"